/**
 * Transforms a raw Firestore API response into a processed format
 * @param data Raw Firestore API response
 * @returns Processed data object
 */
export const transformFirestoreResponse = (data: any): any => {
	if (!data || !data.fields) {
		return data
	}

	const transformValue = (value: any): any => {
		if (!value) return value

		// Handle different Firestore value types
		if (value.stringValue !== undefined) {
			return value.stringValue
		}
		if (value.booleanValue !== undefined) {
			return value.booleanValue
		}
		if (value.integerValue !== undefined) {
			return parseInt(value.integerValue)
		}
		if (value.doubleValue !== undefined) {
			return parseFloat(value.doubleValue)
		}
		if (value.timestampValue !== undefined) {
			const date = new Date(value.timestampValue)
			return {
				seconds: Math.floor(date.getTime() / 1000),
				nanoseconds: (date.getTime() % 1000) * 1000000,
			}
		}
		if (value.arrayValue?.values) {
			return value.arrayValue.values.map(transformValue)
		}
		if (value.arrayValue && !value.arrayValue.values) {
			return []
		}
		if (value.mapValue?.fields) {
			const result: any = {}
			Object.entries(value.mapValue.fields).forEach(([key, val]) => {
				result[key] = transformValue(val)
			})
			return result
		}
		if (value.mapValue && !value.mapValue.fields) {
			return {}
		}
		if (value.nullValue !== undefined) {
			return null
		}

		return value
	}

	// Transform the fields object
	const result: any = {}
	Object.entries(data.fields).forEach(([key, value]) => {
		result[key] = transformValue(value)
	})

	return result
}
